import Table from 'components/CWSTable/Table';
import WarningModal from 'components/Modal/WarningModal';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { Component } from 'react';
import { connect } from 'react-redux';
import {
	TransactionFilterForm,
	transactionColumnConfig,
	ViewTransactionDetails as ViewTransactionDetailsModal,
	VoidTransactionModal,
} from '../../components';
import {
	filterActionCreator,
	filterActionCreatorCount,
	searchBillersActionCreator,
	handlePagination,
	changeShowAll,
	billersPaginationActionCreator,
	handleSortBy,
	toggleIsWarningModalOpen,
} from '../../redux/modules/transaction';
import { viewActionCreator as handleView } from '../../redux/modules/viewtransaction';
import {
	viewActionCreator as handleVoidTransaction,
	openLoader,
	checkPendingVoidRequest,
} from '../../redux/modules/voidTransaction';

import { ReactComponent as Icon } from 'assets/icons/ic-alert.svg';

import ErrorModal, {
	ErrorModalActions,
	ErrorModalBody,
	ErrorSubText,
	ErrorText,
} from 'components/Modal/ErrorModal';
import styles from './TransactionList.module.css';
import FullPageLoader from 'components/Loader/FullPageLoader/FullPageLoader';
const CREATE_VOID_SCOPE = 'bip.create.void.request';

class TransactionList extends Component {
	constructor() {
		super();
		this.handleSort = this.handleSort.bind(this);
		this.handleClosePendingVoidModal =
			this.handleClosePendingVoidModal.bind(this);
		this.handleVoid = this.handleVoid.bind(this);
	}

	componentDidMount() {
		this.props.searchBillersActionCreator('');
		handlePagination(
			{ pageIndex: 1, limit: 25 },
			this.props.filterActionCreator,
			this.props.filterActionCreatorCount
		);
	}

	handleSort(sortBy, sort) {
		handleSortBy(
			{ column: sortBy, sort: sort },
			this.props.filterActionCreator,
			this.props.filterActionCreatorCount
		);
	}

	handleClosePendingVoidModal() {
		this.props.toggleIsWarningModalOpen(false);
	}

	async handleVoid(id, trn) {
		this.props.openLoader();
		try {
			const { data } = await this.props.checkPendingVoidRequest(trn).unwrap();
			if (data.data) {
				this.props.toggleIsWarningModalOpen(true);
				return;
			}
		} catch (e) {
			// failed check request
			// preventing void transaction request creation
			return;
		}

		this.props.handleVoidTransaction(id, trn);
	}

	render() {
		const createVoidScope = this.props.userInfo?.scopes?.find(
			({ scope }) => scope === CREATE_VOID_SCOPE
		);
		return (
			<>
				<ViewTransactionDetailsModal />
				<VoidTransactionModal />
				<TransactionFilterForm />
				<FullPageLoader
					open={
						this.props.isCountTrnxLoading ||
						this.props.isTrnxLoading ||
						this.props.isVoidTrnxLoading ||
						this.props.isViewTrnxLoading
					}
					message={'Please wait while the data is being loaded'}
				/>
				<Table
					data={this.props.data}
					controlledPageCount={this.props.pageCount}
					columns={transactionColumnConfig({
						canVoid: !!createVoidScope,
						handleView: this.props.handleView,
						handleVoid: this.handleVoid,
					})}
					count={this.props.count}
					pageSize={this.props.limit}
					onPageChange={(pageIndex, limit) => {
						handlePagination(
							{ pageIndex, limit },
							this.props.filterActionCreator,
							this.props.filterActionCreatorCount
						);
					}}
					onSort={this.handleSort}
					sortBy={this.props.sorting.sort}
					sort={this.props.sorting.sort_by}
					page={this.props.page}
					preHeader={null}
					modalIsOpen={false}
				/>
				<ErrorModal
					open={this.props.isWarningModalOpen}
					Icon={<Icon className={styles.warningIcon} />}
					onClose={this.handleClosePendingVoidModal}
				>
					<ErrorModalBody>
						<ErrorText>
							<div className={styles.warningSubTextContainer}>
								<span className={styles.warningSubText}>
									There is already a pending void request for this transaction.
								</span>
							</div>
						</ErrorText>
					</ErrorModalBody>
					<ErrorModalActions>
						<PrimaryButton
							className={styles.warningErrorCloseBtn}
							onClick={this.handleClosePendingVoidModal}
						>
							Okay
						</PrimaryButton>
					</ErrorModalActions>
				</ErrorModal>
			</>
		);
	}
}

export default connect(
	(state) => ({
		data: state.transaction.data,
		pageCount: state.transaction.pagination.pageCount,
		count: state.transaction.count,
		page: state.transaction.pagination.page,
		limit: state.transaction.pagination.limit,
		userInfo: state.userInfo,
		sorting: state.transaction.sorting,
		isWarningModalOpen: state.transaction.isWarningModalOpen,
		isTrnxLoading: state.transaction.isLoading,
		isVoidTrnxLoading: state.voidTransaction.isLoading,
		isViewTrnxLoading: state.viewtransaction.isLoading,
		isCountTrnxLoading: state.transaction.isCountLoading,
	}),
	{
		filterActionCreator,
		filterActionCreatorCount,
		handleView,
		handleVoidTransaction,
		openLoader,
		searchBillersActionCreator,
		changeShowAll,
		billersPaginationActionCreator,
		toggleIsWarningModalOpen,
		checkPendingVoidRequest,
	}
)(TransactionList);
